import type { TabId } from "./nav";

/** What the first of the top bar's two right cells holds (B-031, build 14). The cell is 44 px on
 *  every tab, so the Scores ring and the menu never move between tabs: Share where there is
 *  something to share (Swim: this swim, Sets: this set), the Club gear on Club (Scott 2026-09-14:
 *  "keep the Club gear"), and an empty slot elsewhere. A shell with no Club settings sheet gets
 *  the empty slot on Club too, never a dead gear. */
export type TopBarSlot = "share" | "gear" | "empty";

export function topBarSlot(tab: TabId, canOpenClubSettings: boolean): TopBarSlot {
  if (tab === "swim" || tab === "sets") return "share";
  if (tab === "club" && canOpenClubSettings) return "gear";
  return "empty";
}
